package navigation.home.send_message

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val sendMessageUiModule
    get() =
        module {
            factoryOf(::SendMessageScreenModel)
        }